import ApiService from '../common/api.service'
import {
  GETALLROLES, GETALLPERMISSIONS, SAVEPERMISSIONS
} from './actions.type'
import { SET_ERROR } from './mutations.type'

const state = {
  errors: null,
  errorMessage: null,
  errorType: null
}

const getters = {
  error (state) {
    return state.error
  },
  errorMessage (state) {
    return state.errorMessage
  },
  errorType (state) {
    return state.errorType
  }
}

const actions = {
  [GETALLROLES] (context) {
    ApiService.setHeader()
    return ApiService.get('/user_group_roles')
      .then(({ data }) => {
        console.log(data)
        return data.results
      })
      .catch(({ response }) => {
        console.log(response)
        context.commit(SET_ERROR, response)
      })
  },
  [GETALLPERMISSIONS] (context) {
    ApiService.setHeader()
    return ApiService.get('/permissions')
      .then(({ data }) => {
        console.log(data)
        return data.results
      })
      .catch(({ response }) => {
        console.log(response)
        context.commit(SET_ERROR, response)
      })
  },
  [SAVEPERMISSIONS] (context, payload) {
    ApiService.setHeader()
    return ApiService.post('/user_group_roles/', payload)
      .then(({ data }) => {
        console.log(data)
        // context.commit(SET_ORDERLIST, data.results)
        return data
      })
      .catch(({ response }) => {
        console.log(response)
        context.commit(SET_ERROR, response)
        return Promise.reject(response)
      })
  }
}

const mutations = {
  [SET_ERROR] (state, error) {
    state.errors = error.data
    state.errorMessage = error.data
    state.errorType = error.status + ': ' + error.statusText
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
